import {
  getWrapper,
  postWrapper,
  postBlobWrapper,
  postBlobFullResponse,
  putFormDataWrapper,
  putWrapper,
  deleteWrapper,
  getBlobWrapper,
} from "./Wrapper";

//Regist API
export const registerUser = (data) => {
  let url = `/user-register`;
  return postWrapper(url, data);
};

//Send Otp API
export const verifyUser = (data) => {
  let url = `/send-otp `;
  return postWrapper(url, data);
};

export const resendOtp = (data) => {
  let url = `/resend-otp`;
  return postWrapper(url, data);
};

//verify-otp API
export const verifyOtp = (data) => {
  let url = `/verify-otp`;
  return postWrapper(url, data);
};

//verify-otp API
export const OtpVerify = (data) => {
  let url = `/otp-verify `;
  return postWrapper(url, data);
};

//verify-otp API
// export const login = (data) => {
//   let url = `/verify-otp`;
//   return postWrapper(url, data);
// };

//logOut API
export const logOut = () => {
  let url = `/auth/logout`;
  return postWrapper(url, {});
};

//leadGeneration API
export const leadGeneration = (data) => {
  let url = `/api/leads`;
  return postWrapper(url, data);
};
// get-all-loan-requirements
export const getLoanRequirementData = (data) => {
  let url = `/api/eligibilty-calculator/get-all-requirements`;
  return getWrapper(url, data);
};

export const submitContactForm = (data) => {
  let url = `/contact-us`;
  return postWrapper(url, data);
};

export const updateUserProfile = (data) => {
  let url = `/user-update`;
  return putFormDataWrapper(url, data);
};

const deleteAccountEndpoints = {
  lender: (id) => `/lender/delete/${id}`,
  borrower: (id) => `/delete-user?id=${id}`,
  consultant: (id) => `/delete-user?id=${id}`,
};

export const deleteLenderAccount = (id) => deleteWrapper(deleteAccountEndpoints.lender(id));
export const deleteBorrowerAccount = (id) => deleteWrapper(deleteAccountEndpoints.borrower(id));
export const deleteConsultantAccount = (id) => deleteWrapper(deleteAccountEndpoints.consultant(id));

export const getUserData = (uuid) => {
  let url = `/user-get?uuid=${uuid}`;
  return getWrapper(url);
};

export const getAllLoanApplications = (screen, userId, searchSortParams = {}) => {
  let url = `/api/loan/get-all?`;
  if (screen && screen !== "applicationHistory") {
    url += `screen=${screen}&`;
  }
  if (userId) {
    url += `userId=${userId}&`;
  }
  if (searchSortParams.searchQuery) {
    url += `searchQuery=${encodeURIComponent(searchSortParams.searchQuery)}&`;
  }
  if (searchSortParams.sortBy) {
    url += `sortBy=${encodeURIComponent(searchSortParams.sortBy)}&`;
  }
  if (searchSortParams.order) {
    url += `order=${encodeURIComponent(searchSortParams.order)}&`;
  }
  if (url.endsWith("&") || url.endsWith("?")) {
    url = url.slice(0, -1);
  }
  return getWrapper(url);
};

export const getUserNotificationSettings = (uuid) => {
  let url = `/api/v1/user-notification/get?uuid=${uuid}`;
  return getWrapper(url);
};

export const updateUserNotificationSettings = (data) => {
  let url = `/api/v1/user-notification/update`;
  return putWrapper(url, data);
};

export const applyLoan = (data) => {
  let url = "/api/loan/apply";
  return postWrapper(url, data);
};
export const uploadDoc = (data) => {
  let url = "/api/loan/docx-upload";
  return postWrapper(url, data);
};

export const getResumedApplications = (userId) => {
  let url = `/api/loan/resume?userId=${userId}`;
  return getWrapper(url);
};
export const getApplicationDetails = (applicationId) => {
  let url = `/api/loan/get-application-details?applicationId=${applicationId}`;
  return getWrapper(url);
};

export const getLoanDocuments = (applicationId) => {
  let url = `/api/loan/documents?applicationId=${applicationId}`;
  return getWrapper(url);
};

export const notify = (notificationRequest) => {
  let url = `/api/notify`;
  return postWrapper(url, notificationRequest);
};

export const fetchCompanyDetailbyGst = (gst) => {
  let url = `/api/get-company-details?gst=${gst}`;
  return getWrapper(url);
};

export const fetchCompanyDetailbyCIN = (cin) => {
  let url = `/api/get-company-summary?cinNumber=${cin}`;
  return getWrapper(url);
};

export const fetchCompanyDocbyCIN = (cin) => {
  let url = `/api/order?cinNumber=${cin}`;
  return postWrapper(url, {});
};

export const createProposal = (data) => {
  let url = `/offer/create`;
  return postWrapper(url, data);
};

export const updateOffer = (data) => {
  let url = `/offer/update`;
  return postWrapper(url, data);
};

export const getProposalsByLenderId = (lenderId, status, page, size, searchSortParams = {}) => {
  let url = `/proposal/get-by-id-and-status-customized?lenderId=${lenderId}`;
  if (page !== undefined && page !== null) {
    url += `&page=${page}`;
  }
  if (size !== undefined && size !== null) {
    url += `&size=${size}`;
  }
  if (status) {
    url += `&status=${status}`;
  }
  if (searchSortParams.searchQuery) {
    url += `&searchQuery=${encodeURIComponent(searchSortParams.searchQuery)}`;
  }
  if (searchSortParams.sortBy) {
    url += `&sortBy=${encodeURIComponent(searchSortParams.sortBy)}`;
  }
  if (searchSortParams.order) {
    url += `&order=${encodeURIComponent(searchSortParams.order)}`;
  }
  return getWrapper(url);
};

export const getProposalByLenderAndProposal = (lenderId, proposalId) => {
  let url = `/proposal/get-by-lender-and-proposal?lenderId=${lenderId}&proposalId=${proposalId}`;
  return getWrapper(url);
};

export const getS3UrlByKeyBase64 = (keyBase64) => {
  const url = `/s3/get-url/${keyBase64}`;
  return getWrapper(url);
};

export const updateProposalStatus = (lenderId, proposalId, status, rejectedReason) => {
  let url = `/proposal/update?lenderId=${lenderId}&proposalId=${proposalId}&status=${status}`;
  if (rejectedReason && status === "rejected") {
    url += `&rejectedReason=${encodeURIComponent(rejectedReason)}`;
  }
  return postWrapper(url);
};

export const getDashboardDetails = (lenderId) => {
  let url = `/dashboard/lender?lenderId=${lenderId}`;
  return getWrapper(url);
};

export const getOrganizationDetails = (lenderId) => {
  let url = `/organization/${lenderId}`;
  return getWrapper(url);
};

export const updateOrganizationDetails = (data) => {
  let url = `/organization`;
  return postWrapper(url, data);
};

export const getAllPublishedBlogs = (contentType) => {
  let url = `api/blog/published`;
  if (contentType) {
    url += `?contentType=${encodeURIComponent(contentType)}`;
  }
  return getWrapper(url, true);
};

export const getBlogByTitle = (title) => {
  let url = `api/blog/get-by-title?title=${encodeURIComponent(title)}`;
  return getWrapper(url, true);
};

export const getRegions = () => {
  let url = `/get-region`;
  return getWrapper(url);
};

export const getDashboardDataforBorrower = (userID) => {
  let url = `/dashboard/borrower?userID=${userID}`;
  return getWrapper(url);
};

export const getDashboardDataforConsultant = (userID) => {
  let url = `/dashboard/consultant?userID=${userID}`;
  return getWrapper(url);
};
export const getAllOffers = (borrowerId, status) => {
  let url = `/offer/get-offer?borrowerId=${borrowerId}`;
  if (status) {
    url += `&status=${status}`;
  }
  return getWrapper(url);
};

export const getOfferById = (id) => {
  let url = `/offer/get-offer-by-id?id=${id}`;
  return getWrapper(url);
};

export const updateBorrowerOffer = ({ offerId, status, borrowerId, rejectedReason }) => {
  let url = `/borrower-offer/update?offerId=${offerId}&status=${status}&borrowerId=${borrowerId}`;
  url += `&rejectedReason=${encodeURIComponent(rejectedReason || "")}`;
  return postWrapper(url);
};

export const getOffersByLenderId = (lenderId, searchSortParams = {}) => {
  let url = `/offer/get-offer-by-lenderId?lenderId=${lenderId}`;
  if (searchSortParams.searchQuery) {
    url += `&searchQuery=${encodeURIComponent(searchSortParams.searchQuery)}`;
  }
  if (searchSortParams.sortBy) {
    url += `&sortBy=${encodeURIComponent(searchSortParams.sortBy)}`;
  }
  if (searchSortParams.order) {
    url += `&order=${encodeURIComponent(searchSortParams.order)}`;
  }
  return getWrapper(url);
};

export const getApplicationTrackingDetail = (applicationId) => {
  let url = `/api/loan/track?applicationId=${applicationId}`;
  return getWrapper(url);
};

export const updateOfferStatus = (offerId, status) => {
  let url = `/offer/status-update?status=${status}&offerId=${offerId}`;
  return putWrapper(url);
};

export const submitQuery = (formData) => {
  let url = `/converstaion`;
  return postWrapper(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const markNotificationAsRead = async (notificationId = null, userId = null) => {
  const url = notificationId 
    ? `/api/notifications/mark-read?notificationId=${notificationId}`
    : `/api/notifications/mark-read?role=USER&userId=${userId}`;
  return await postWrapper(url);
};

export const getBorrowerList = (lenderId) => {
  let url = `/converstaion/borrower-list/${lenderId}`;
  return getWrapper(url);
};

export const getLenderConversation = (lenderId, borrowerId) => {
  let url = `/converstaion/lender?lenderId=${lenderId}&borrowerId=${borrowerId}`;
  return getWrapper(url);
};

export const getIndustries = () => {
  let url = `/industry/industry`;
  return getWrapper(url);
};

export const getSectors = (industry) => {
  let url = `/industry/sector?industry=${industry}`;
  return getWrapper(url);
};

export const getNotifications = (userId, page = 0, size = 10) => {
  let url = `/api/notifications?role=USER&userId=${userId}&page=${page}&size=${size}`;
  return getWrapper(url);
};

export const likeBlog = (userId, blogId, like) => {
  let url = `/api/blog/like?userId=${userId}&blogId=${blogId}&like=${like}`;
  return postWrapper(url);
};

export const commentBlog = (userId, blogId, comment) => {
  let url = `/api/blog/comment?userId=${userId}&blogId=${blogId}&comment=${encodeURIComponent(comment)}`;
  return postWrapper(url);
};

export const editComment = (userId, blogId, comment) => {
  let url = `/api/blog/edit-comment?userId=${userId}&blogId=${blogId}&comment=${encodeURIComponent(comment)}`;
  return postWrapper(url);
};

export const updateComment = (data) => {
  let url = `/api/blog/update`;
  return postWrapper(url, data);
};

export const deleteComment = (data) => {
  let url = `/api/blog/delete`;
  return deleteWrapper(url, data);
};

export const getBlogLikesAndComments = (blogId) => {
  let url = `/api/blog/get-likes-and-comments?blogId=${blogId}`;
  return getWrapper(url);
};

export const getBlogLikesAndCommentsOfUser = (blogId, userId) => {
  let url = `/api/blog/get-likes-and-comments-of-user?blogId=${blogId}&userId=${userId}`;
  return getWrapper(url);
};

export const getLocationByPincode = (pincode) => {
  let url = `https://api.postalpincode.in/pincode/${encodeURIComponent((pincode || "").toString().trim())}`;
  return getWrapper(url, true);
}
export const subscribeNewsletter = (data) => {
  let url = `/subscribe/create`;
  return postWrapper(url, data);
};

export const getLendersList = () => {
  let url = `/lender/get-lender`;
  return getWrapper(url);
};

export const getLenderById = (lenderId) => {
  let url = `/lender/get-lender-by-id?id=${lenderId}`;
  return getWrapper(url);
};

export const createLoanApplicationProposal = async (proposalData) => {
  const formData = new FormData();
  
  if (proposalData.files?.cma) {
    formData.append('cma', proposalData.files.cma);
  }
  if (proposalData.files?.onePager) {
    formData.append('onePager', proposalData.files.onePager);
  }
  
  formData.append('applicationId', proposalData.applicationId || '');
  formData.append('applicationNumber', proposalData.applicationNumber || '');
  formData.append('userId', proposalData.user_id || proposalData.userId || '');
  formData.append('borrowerId', proposalData.borrowerId || '');
  formData.append('proposalBrief', proposalData.proposalBrief || '');
  
  if (proposalData.lenderId) {
    const lenderIds = Array.isArray(proposalData.lenderId)
      ? proposalData.lenderId
      : [proposalData.lenderId];
    lenderIds
      .filter(Boolean)
      .forEach((id) => formData.append('lenderId', id));
  }
  
  const url = `/proposal/create`;
  return postWrapper(url, formData);
};


export const updateProposalDetails = (proposalData) => {
  const formData = new FormData();

  ['cma', 'onePager'].forEach((key) => {
    const file = proposalData?.files?.[key];
    if (file) formData.append(key, file);
  });

  const fields = {
    id: proposalData.id,
    applicationId: proposalData.applicationId,
    applicationNumber: proposalData.applicationNumber,
    userId: proposalData.userId,
    borrowerId: proposalData.borrowerId,
    proposalBrief: proposalData.proposalBrief,
  };

  Object.entries(fields).forEach(([key, value]) => {
    const hasValue = value !== undefined && value !== null && (typeof value === 'number' || (typeof value === 'string' && value !== ''));
    if (hasValue) formData.append(key, value);
  });

  const lenderIds = Array.isArray(proposalData.lenderId)
    ? proposalData.lenderId
    : (proposalData.lenderId ? [proposalData.lenderId] : []);
  lenderIds.filter(Boolean).forEach((id) => formData.append('lenderId', id));

  let url = `/proposal/update-proposal-details`;
  return postWrapper(url, formData);
};

export const generateOnePager = (userId) => {
  let url = `/api/one-pager?userId=${encodeURIComponent(userId)}`;
  return postWrapper(url, undefined, {
    headers: { Accept: "application/json" },
  });
};

export const generateOnePagerByApplicationNumber = (applicationNumber, maskData = false) => {
  let url = `/api/one-pager?applicationNumber=${encodeURIComponent(applicationNumber)}&maskData=${maskData}`;
  return postWrapper(url);
};

export const generateCMA = (userId) => {
  let url = `/api/cma?userId=${encodeURIComponent(userId)}`;
  return postBlobWrapper(url, undefined);
};

export const generateCMAByApplicationNumber = (applicationInfo) => {
  const appId = applicationInfo?.applicationId ?? applicationInfo?.applicationNumber ?? applicationInfo;
  const appNumber = String(appId ?? "").trim();
  if (!appNumber) {
    return Promise.reject(new Error("Application ID is required to generate CMA report"));
  }
  const params = new URLSearchParams({ applicationNumber: appNumber });
  return postBlobFullResponse(`/api/cma?${params.toString()}`, null);
};

export const getOnePagerByAppNumber = (applicationInfo, additionalParams = {}) => {
  const appId = applicationInfo?.applicationId ?? applicationInfo?.applicationNumber ?? applicationInfo;
  const appNumber = String(appId ?? "").trim();
  if (!appNumber) {
    return Promise.reject(new Error("Application ID is required to generate one pager"));
  }
  const params = new URLSearchParams({ applicationNumber: appNumber });
  Object.entries(additionalParams || {}).forEach(([key, value]) => {
    if (value != null) params.append(key, String(value));
  });
  return postBlobFullResponse(`/api/one-pager?${params.toString()}`, null);
};

export const downloadOnePagerByKey = (key) => {
  const url = `/download?key=${encodeURIComponent(key)}`;
  return getBlobWrapper(url);
};